import DefaultRelate from "../../defaultFields/Relate/Relate";
import  sAction  from "sAction";

export default class Relate extends DefaultRelate {
  saveField(data, doUpdate = true) {
    sAction.saveField(data, doUpdate);
  }
}
